module.exports = __webpack_public_path__ + "media/images/icon__point--text@2x-18ad22efe490d1c020f8bd63349ee52f.png";